import { Categories, Category } from 'framework/categories'
import { EcommerceService } from 'services'

class CategoryService extends EcommerceService {
  getCategories() {
    const self = this
    const url = '/categories'
    const req = self.setUrl(url).get()
    return req
  }

  getCategoryById(categoryId: string) {
    const self = this
    const url = `/categories/${categoryId}`
    const req = self.setUrl(url).get()
    return req
  }

  parser(data: any[]): Categories {
    const categories = (data
      .map((item) => {
        if (item.slug !== '') {
          const category: Category = {
            id: item.id,
            slug: item.slug,
            name: item.descricao,
            header: {
              url: (false as unknown) as string,
            },
            description: '',
          }

          if (item.subcategorias.length > 0) {
            category.categories = this.parser(item.subcategorias)
          }

          return category
        }

        return null
      })
      .filter(Boolean) as unknown) as Categories
    return categories
  }
}

export default CategoryService
